import React from "react";
import { Route } from "react-router-dom";
import SponsorDashboard from "../../screens/sponsor/SponsorDashboard";
import ProgramDetailedView from "../../screens/sponsor/ProgramDetailedView";

export const sponsorRoutes = [
  <Route key="sponsor-dashboard" path="/" element={<SponsorDashboard />} />,
  <Route
    key="program-detail-page"
    path="/programs/:programId"
    element={<ProgramDetailedView />}
  />,
];
